import React from 'react';
import styled from 'styled-components';
import Logo from '../atoms/Logo';

const Holder = styled.div`
  display: flex;
  align-items: center;
  p {
    line-height: 1;
    letter-spacing: 0.2rem;
    margin: 0.6rem 0 0 3rem;
  }
`;

function PreHead(props) {
    return (
      <Holder>
        <Logo/>
        <p className="roboto">DISCOVERY EXERCISES</p>
      </Holder>
    )
}

export default PreHead;
